import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

export const GrowContainer = forwardRef(({ children, onScroll, onReachEnd, className, hideScrollbar, scrollbarColor }, ref) => {

  const handleScroll = (event) => {
    const target = event.target;

    if (target.scrollTop == 0) onScroll?.(0)
    if (target.scrollTop && target.scrollTop < target.clientHeight) {
      onScroll && onScroll(target.scrollTop)
    }
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      onReachEnd && onReachEnd();
    }
  }

  const childrenRef = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollToTop() {
      if (childrenRef && childrenRef.current) {
        childrenRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    },
  }));

  return (
    <ParentContainer>
      <ChildrenContainer
        ref={childrenRef}
        scrollbarColor={scrollbarColor}
        hideScrollbar={hideScrollbar}
        className={className}
        onScroll={handleScroll}
      >
        {children}
      </ChildrenContainer>
    </ParentContainer>
  )
})

GrowContainer.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func,
  onReachEnd: PropTypes.func,
  className: PropTypes.string
};

const ParentContainer = styled.div`
  flex-grow: 1;
  position: relative;
`;

const ChildrenContainer = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: auto;
    
    scrollbar-width: none;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    @media only screen and (min-width: 768px) {
      scrollbar-width: thin;
      scrollbar-color: #E3E3E3 transparent;

      ::-webkit-scrollbar {
        width: 16px;
        height: 16px;
        background: transparent;
      }

      ::-webkit-scrollbar-track-piece  {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb:vertical {
        background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb:horizontal {
        background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #E3E3E3;
      }
    }
  `}
`;